import { isArray } from '../isArray/isArray';
import { isNumber } from '../isNumber/isNumber';
/**
 * Convert array of any structure to matrix by columns.
 *
 * @param {any[]} arr - Array of any type.
 * @param {number} columns - Number of columns in output matrix.
 */
export function arrayToMatrix(arr, columns) {
    if (isArray(arr) && isNumber(columns) && columns > 0) {
        return arr.reduce((rows, v, i) => (i % columns == 0 ? rows.push([v]) : rows[rows.length - 1].push(v)) && rows, []);
    }
    throw new Error('Invalid arguments');
}
